import HelpTextIcon from "../../../Components/InformationIcon";
import DisplayField from "../../../Components/DisplayField";

function LogTradeStepOne({ prerequisitesChecked, setPrerequisitesChecked }) {
    const handleCheckboxToggle = () => {
        setPrerequisitesChecked(!prerequisitesChecked);
    };

    return (
        <div>
            <h3 className="text-2xl font-semibold mb-8">
                Steg 1 -{" "}
                <span className="text-lg font-medium text-accent">
                    Förbered anslutning till LogTrade
                </span>
            </h3>
            <div className="flex items-start">
                <div className="flex flex-col space-y-8 w-3/4">
                    <label className="block font-medium">
                        Följande steg ska genomföras för att aktivera Zendr som
                        transportör i LogTrade:
                    </label>
                    <ul className="text-md font-medium list-decimal list-outside pl-6 space-y-4">
                        <li>
                            <div className="flex items-start">
                                <p>
                                    Ta kontakt med er säljkontakt hos LogTrade
                                    för att lägga till iol-modulen, och be dem
                                    aktivera Zendr som en transportör.
                                </p>
                                <HelpTextIcon infoText="Om du saknar en direktkontakt, skicka ett e-postmeddelande till Zendr (extensions@zendr.se) för att få hjälp med att hitta rätt person." />
                            </div>
                        </li>
                        <li>
                            <DisplayField
                                label="Nödvändig information till kontakt på LogTrade:"
                                value="Lägg till iol-modulen och aktivera Zendr som en transportör på ert LogTrade konto."
                            />
                        </li>
                        <div>
                            Vid oklarheter, kontakta er kundansvarige på Zendr
                            för hjälp.
                        </div>
                        <li>
                            <p className="mb-4 mt-4">
                                När förberedelserna är genomförda, kryssa i
                                rutan och fortsätt till nästa steg.
                            </p>
                            <div className="flex items-center mb-4">
                                <input
                                    type="checkbox"
                                    name="prerequisites"
                                    checked={prerequisitesChecked}
                                    onChange={handleCheckboxToggle}
                                    className="form-checkbox w-5 h-5"
                                    style={{
                                        accentColor: "rgba(76, 80, 175, 1)",
                                    }}
                                />
                                <label className="ml-2">
                                    Jag har genomfört ovanstående steg.
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default LogTradeStepOne;
